/** @jsx h */
import { h } from 'preact'

const CloseIcon = ({
  style = {},
  fill = 'none',
  stroke = '#000',
  width = '42.073',
  height = '42.073',
  className = '',
  viewBox = '0 0 42.073 42.073'
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='9.99 9.99 22.09 22.09'
    aria-hidden='true'
  >
    <g transform='translate(21.037) rotate(45)'>
      <g stroke={stroke} strokeMiterlimit='{10}' fill={fill} transform='translate(14.131)'>
        <rect stroke='none' width='1.488' height='29.75' />
        <rect fill='none' x='0.5' y='0.5' width='0.488' height='28.75' />
      </g>
      <g stroke={stroke} strokeMiterlimit='{10}' fill={fill} transform='translate(0 14.131)'>
        <rect stroke='none' width='29.75' height='1.488' />
        <rect fill='none' x='0.5' y='0.5' width='28.75' height='0.488' />
      </g>
    </g>
    <rect fill='none' width='30' height='30' transform='translate(7 7)' />
  </svg>
)

export default CloseIcon
